import(/* webpackMode: "eager" */ "/home/runner/work/infra-idp-app/infra-idp-app/apps/auth-iframe-app-new/src/app/(routes)/layout.tsx");
